import { networkContactFilter, dateFilter, networkContactSourceFilter } from '@/utils/filters';
export default {
    name: 'GridDesktop',
    data() {
        return {
            notAvaliableMessage: 'Não disponível'
        };
    },
    props: {
        row: {
            type: Object,
            default: {}
        },
        contactsGrid: {
            type: Object,
            default: {}
        }
    },
    methods: {
        networkContactFilter,
        dateFilter,
        networkContactSourceFilter
    }
};
